import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReportsProps } from '../../types/props';

export const Reports: React.FC<ReportsProps> = ({ fiscalSponsorId }) => {
  return (
    <Box>
      <Typography variant="h4">Reports</Typography>
    </Box>
  );
}; 